import { fetchPersea } from "@/config/axios/config-axios";
import { GetAccountTargetSupportedSocialMediaParams } from "./types";

export const getAccountTargetSupportedSocialMedia = async (params: GetAccountTargetSupportedSocialMediaParams) => {
  return await fetchPersea(`/account-target/supported-social-media`, 'GET', params);
};